import {
  isRSYS,
  type RSYS,
  RSYS_NUMBER_VARIANTS,
  type RSYSNum,
  type USYS,
  USYS_NUMBER_VARIANTS,
  type USYSNum,
} from '../../../../schema/system/entry.js';

export type SystemNumber = RSYSNum | USYSNum;

/**
 * Returns whether the given system number is a of type RSYS or USYS.
 *
 * @param systemNum Number representation of the system
 * @returns RSYS if the system number is of type RSYS, USYS otherwise
 */
export function getSystemKeyFromNumber(systemNum: SystemNumber): RSYS | USYS {
  if (isRSYS(systemNum)) {
    return RSYS_NUMBER_VARIANTS[systemNum];
  }

  return USYS_NUMBER_VARIANTS[systemNum];
}
